module.exports = __webpack_public_path__ + "static/media/ColorGuy.19f1be0d.jpeg";